import { coreMessages, type AppLocale } from './base-messages';

export const de: AppLocale = {
  ...coreMessages,
  dataTable: {
    rowModeLabel: 'Row display',
    rowModeEllipsis: 'Truncate (…)',
    rowModeScroll: 'Single line + horizontal scroll',
    rowModeWrap: 'Wrap lines',
    columnsLabel: 'Columns',
    reorderColumnHint: 'Drag the handle to move this column',
    resetThisTablePrefs: 'Reset this table',
    resetThisTablePrefsTitle: 'Clear saved layout for this table only (row mode, columns, order, widths). Does not change your global user settings.',
    dataOperationsLabel: 'Datenvorgänge',
    operationExportExcel: 'Excel herunterladen',
    operationDownloadTemplate: 'Vorlage herunterladen',
    operationUploadTemplate: 'Vorlage hochladen',
    operationImportHistory: 'Importverlauf',
    operationFieldDictionary: 'Feldwörterbuch',
    operationUnsupported: 'Diese Tabelle unterstützt diesen Vorgang nicht.',
    operationNoPermission: 'Sie haben keine Berechtigung für diesen Vorgang.',
    operationNotReady: 'Dieser Vorgang ist noch nicht bereit.',
    customFieldColumnsSectionLabel: 'Benutzerdefinierte Felder',
    importModalTitle: 'Vorlage hochladen',
    importChooseFile: 'CSV-Datei auswählen',
    importChooseFileHint: 'Füllen Sie die aus dieser Tabelle heruntergeladene Vorlage aus und laden Sie sie hoch.',
    importNoFile: 'Keine Datei ausgewählt.',
    importSummary: 'Importzusammenfassung',
    importReadyRows: 'Bereite Zeilen',
    importErrorRows: 'Fehlerhafte Zeilen',
    importWarnings: 'Warnungen',
    importUnknownHeaders: 'Unbekannte Spalten',
    importMissingRequiredHeaders: 'Fehlende Pflichtspalten',
    importPreview: 'Vorschau',
    importSubmit: 'Import starten',
    importCancel: 'Abbrechen',
    importParsing: 'Datei wird gelesen...',
    importSubmitting: 'Import läuft...',
    importNoValidRows: 'Es gibt keine gültigen Zeilen für den Import.',
    importFailed: 'Import fehlgeschlagen.',
    importSucceeded: 'Import abgeschlossen.',
    operationExportCsv: 'CSV herunterladen',
    operationExportPdf: 'PDF herunterladen',
    operationNoRows: 'Es gibt keine sichtbaren Zeilen zum Exportieren.',
    importUnknownHeader: 'Unbekannte Spalte: {header}',
    importMissingRequiredHeader: 'Erforderliche Spalte fehlt: {header}',
    importRequiredCell: '{header} ist erforderlich.',
    importMaxRowsExceeded: 'Die Datei enthält mehr als {maxRows} Zeilen; nur die ersten {maxRows} Zeilen wurden ausgewertet.',
    refreshLabel: 'Aktualisieren',
    focusModeEnterLabel: 'Tabelle fokussieren',
    focusModeFullscreenLabel: 'Vollbild öffnen',
    focusModeExitLabel: 'Tabellenfokus beenden',
    horizontalScrollLabel: 'Tabellenspalten scrollen',
    selectionModeLabel: 'Zeilen auswählen',
    selectAllRowsLabel: 'Alle Zeilen auswählen',
    selectRowLabel: 'Zeile auswählen',
    bulkSelectedLabel: '{count} ausgewählt',
    bulkActionsLabel: 'Massenaktionen',
    tableSettingsLabel: 'Tabelleneinstellungen',
    appearanceSectionLabel: 'Darstellung',
    columnsSectionLabel: 'Spalten',
    rowActionsLabel: 'Zeilenaktionen',
  },
  passwordReset: {
    title: 'Neues Passwort festlegen',
    description: 'Wählen Sie ein starkes neues Passwort, das nur Ihnen bekannt ist.',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Neues Passwort bestätigen',
    passwordHelp: 'Verwenden Sie mindestens 12 Zeichen und mindestens drei dieser Typen: Kleinbuchstaben, Großbuchstaben, Zahl, Sonderzeichen.',
    mismatch: 'Die Passwörter stimmen nicht überein.',
    invalidLink: 'Der Link zum Zurücksetzen des Passworts fehlt, ist ungültig oder abgelaufen.',
    submit: 'Passwort aktualisieren',
    submitting: 'Passwort wird aktualisiert...',
    success: 'Ihr Passwort wurde aktualisiert. Sie können sich jetzt mit dem neuen Passwort anmelden.',
    backToLogin: 'Zurück zur Anmeldung',
    requestTitle: 'Link zum Zurücksetzen des Passworts senden',
    requestDescription: 'Ein einmaliger, 30 Minuten gültiger Link wird an die registrierte E-Mail-Adresse des Benutzers gesendet. Das aktuelle Passwort bleibt bis zur Verwendung des Links unverändert.',
    requestSend: 'Link senden',
    requestSending: 'Wird gesendet...',
    requestSuccess: 'Der Link zum Zurücksetzen des Passworts wurde zur Zustellung angenommen.',
    requestError: 'Der Link zum Zurücksetzen des Passworts konnte nicht gesendet werden.',
    selfServiceOpen: 'Passwort vergessen',
    selfServiceTitle: 'Passwort vergessen',
    selfServiceDescription: 'Geben Sie die E-Mail-Adresse Ihres Unternehmenskontos ein. Bei Übereinstimmung wird ein einmaliger, 30 Minuten gültiger Link gesendet.',
    selfServiceEmailLabel: 'E-Mail',
    selfServiceSubmit: 'Link anfordern',
    selfServiceSubmitting: 'Anfrage wird gesendet...',
    selfServiceAcknowledgement: 'Wenn diese E-Mail registriert ist, wird ein Link zum Zurücksetzen gesendet. Prüfen Sie bitte Posteingang und Spam-Ordner.',
    selfServiceClose: 'Schließen',
    selfServiceCancel: 'Abbrechen',
    selfServiceError: 'Die Anfrage konnte nicht abgeschlossen werden. Bitte versuchen Sie es später erneut.',
    selfServiceRateLimited: 'Zu viele Anfragen. Bitte versuchen Sie es später erneut.',
  },
  relationshipGraph: {
    sourceColumn: 'Quelle',
    relationshipColumn: 'Beziehung',
    targetColumn: 'Verknüpfter Datensatz',
    showDetails: 'Details anzeigen',
    hideDetails: 'Details ausblenden',
    controlsLabel: 'Kartensteuerung',
    title: 'Beziehungskarte',
    diagramLabel: 'Datensatzbeziehungen',
    diagramHelp: 'Wählen Sie eine Karte aus, um gespeicherte Verbindungen zu prüfen.',
    detailsTitle: 'Datensatzdetails',
    connectionsTitle: 'Verbindungen',
    noConnections: 'Keine Verbindungen',
    loading: 'Beziehungen werden geladen…',
    forbidden: 'Sie haben keinen Zugriff auf diese Beziehungen.',
    error: 'Beziehungen konnten nicht geladen werden. Schließen und erneut versuchen.',
    empty: 'Dieser Datensatz hat keine anzeigbaren Verbindungen.',
    invalid: 'Beziehungsdaten konnten nicht geprüft werden. Schließen und erneut versuchen.',
    close: 'Beziehungskarte schließen',
    zoomIn: 'Vergrößern',
    zoomOut: 'Verkleinern',
    fitView: 'Karte einpassen',
  },
  permissionPicker: {
    application: 'Anwendung',
    module: 'Modul',
    action: 'Aktion',
    permissions: 'Berechtigungen',
    description: 'Beschreibung',
    selection: 'Auswahl',
    sharedPermissions: 'Gemeinsame Berechtigungen',
    selectedPermissions: '{count} Berechtigungen ausgewählt',
    selectedOnly: 'Nur ausgewählte',
    unselectedOnly: 'Nur nicht ausgewählte',
    selectedFirst: 'Ausgewählte zuerst',
    noPermissions: 'Keine Berechtigungen',
  },
  errors: {
    ...coreMessages.errors,
    unknown: 'Ein unbekannter Fehler ist aufgetreten',
    network: 'Verbindung zum Server fehlgeschlagen. Bitte überprüfen Sie Ihre Internetverbindung.',
    timeout: 'Zeitlimit überschritten. Bitte versuchen Sie es erneut.',
    badRequest: 'Ungültige Anfrage',
    unauthorized: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
    forbidden: 'Sie haben keine Berechtigung für diese Aktion.',
    notFound: 'Die angeforderte Ressource wurde nicht gefunden',
    tooManyRequests: 'Zu viele Anfragen gesendet. Bitte versuchen Sie es später erneut.',
    internalServerError: 'Serverfehler aufgetreten. Bitte versuchen Sie es später erneut.',
    badGateway: 'Server vorübergehend nicht verfügbar',
    serviceUnavailable: 'Dienst vorübergehend nicht verfügbar',
    gatewayTimeout: 'Server antwortet nicht',
    serverErrorWithStatus: 'Serverfehler ({status})',
  },
  common: {
    databaseUnavailableDeveloperHint: 'Entwicklerhinweis: In der lokalen Entwicklung liegt das meist an deaktiviertem VPN oder fehlender IP-Freigabe. Bitte VPN und Datenbankzugriff prüfen.',
    ...coreMessages.common,
    requestTimeout: 'The request timed out. Please try again.',
    backendConnectionErrorDev: 'Verbindung zum Backend-Server nicht möglich. Bitte stellen Sie sicher, dass der Server läuft ({apiUrl}).',
    backendConnectionErrorProd: 'Verbindung zum Backend-Server nicht möglich. Bitte versuchen Sie es später erneut.',
    systemUpdating: 'System wird aktualisiert...',
    serverConfiguring: 'Server wird konfiguriert, bitte warten...',
    forbidden: 'Access denied.',
    network: 'Network error.',
    select: 'Auswählen',
    cancel: 'Abbrechen',
    save: 'Speichern',
    saving: 'Wird gespeichert...',
    edit: 'Bearbeiten',
    view: 'Ansehen',
    copy: 'Kopieren',
    delete: 'Löschen',
    appLauncher: 'Anwendungen',
    allApps: 'Alle Anwendungen',
    loading: 'Wird geladen...',
    noData: 'Keine Daten',
    code: 'Code',
    profileMenu: 'Profilmenü',
    selectLanguage: 'Sprache wählen',
    perPage: 'Pro Seite',
    firstPage: 'Erste Seite',
    previousPage: 'Vorherige Seite',
    nextPage: 'Nächste Seite',
    lastPage: 'Letzte Seite',
    pleaseWait: 'Bitte warten',
    migrationDescription: 'Datenbankaktualisierung wird durchgeführt. Dies kann einige Sekunden dauern.',
    changeText: 'Ändern',
    deleteLogo: 'Logo löschen',
    logoUploadHint: 'Maximale Dateigröße: 5 MB. Unterstützte Formate: JPEG, PNG, GIF, WebP',
    deleteAvatar: 'Profilbild löschen',
    avatarUploadHint: 'Max. 5 MB. JPEG, PNG, GIF, WebP.',
    newRecord: 'Neuer Eintrag',
    noPermission: 'Sie haben keine Berechtigung',
    searchPlaceholder: 'Suchen...',
    allStatuses: 'Alle Status',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    clearFilters: 'Filter zurücksetzen',
    all: 'Alle',
    clickToChangeStatus: 'Klicken, um Status zu ändern',
    noChangePermission: 'Keine Berechtigung zum Ändern des Status',
    statusDistribution: 'Statusverteilung',
    hide: 'Ausblenden',
    show: 'Anzeigen',
    companies: 'Companies',
    adminConsole: 'Admin-Konsole',
    manageAccount: 'Konto verwalten',
    manageYourAccount: 'Konto verwalten',
    notificationsTitle: 'Benachrichtigungen',
    notificationsUnread: 'ungelesen',
    notificationsTypesMuted: 'Typen stummgeschaltet',
    notificationsViewAll: 'Alle anzeigen',
    notificationsPreferences: 'Einstellungen',
    notificationsMutedLabel: 'Stummgeschaltet',
    notificationsEmpty: 'Keine Benachrichtigungen',
    selectAll: 'Alle auswählen',
    id: 'ID',
    remove: 'Entfernen',
    syncDeletedResult: '{count} verwaiste Einträge entfernt.',
    distributionByTable: 'Verteilung nach Tabelle (Kontext)',
    distributionByLocale: 'Verteilung nach Sprache',
    translationReport: 'Übersetzungsstatus-Verteilung',
    page: 'Seite',
    rows: 'Zeilen',
    actions: 'Aktionen',
    create: 'Erstellen',
    search: 'Suchen',
    closeSearch: 'Suche schließen',
    help: 'Hilfe',
    helpCenter: 'Hilfezentrum',
    helpAboutPage: 'Über diese Seite',
    helpDocumentation: 'Dokumentation',
    helpKeyboardShortcuts: 'Tastenkürzel',
    helpWhatsNew: 'Neuigkeiten',
    helpF1Hint: 'Drücken Sie F1, um Hilfe zu dieser Seite zu erhalten',
    helpNoDocsForPage: 'Für diese Seite ist noch keine Dokumentation verfügbar',
    aiAssistantTitle: 'QubePro KI-Assistent',
    aiAssistantButton: 'KI-Assistent',
    aiAssistantUnavailable: 'Der KI-Assistent ist derzeit nicht verfügbar.',
    appearancePreference: 'Darstellungspräferenz',
    modalControlPlacement: 'Position der Formularsteuerung',
    modalControlPlacementHint: 'Legt die Position der Schließen- und Vollbildsteuerung in Formularen fest.',
    modalControlPlacementSystem: 'System (Empfohlen)',
    modalControlPlacementWindows: 'Windows',
    modalControlPlacementMacos: 'macOS',
    productTour: {
      start: 'Produkttour starten',
      restart: 'Produkttour neu starten',
      navigationTitle: 'Seitenleiste und Module',
      navigationDescription: 'Über die Seitenleiste erreichen Sie berechtigte Module und Seiten und können Bereiche ein- oder ausklappen.',
      appsTitle: 'Anwendungen',
      appsDescription: 'Öffnen Sie hier Ihre QubePro-Anwendungen und wechseln Sie zwischen ihnen.',
      profileTitle: 'Profil und Unternehmen',
      profileDescription: 'Verwalten Sie hier Ihr Profil, das ausgewählte Unternehmen und Ihre Spracheinstellungen.',
      aiTitle: 'QubePro AI',
      aiDescription: 'Öffnen Sie den QubePro-KI-Assistenten für Hilfe zur aktuellen Seite.',
      helpTitle: 'Hilfezentrum',
      helpDescription: 'Öffnen Sie die Dokumentation oder starten Sie diese Produkttour jederzeit neu.',
      next: 'Weiter',
      previous: 'Zurück',
      done: 'Fertig',
      close: 'Schließen',
      neverShowAgain: 'Nicht mehr automatisch anzeigen',
      progress: '{{current}} / {{total}}',
    },
    userExtensions: 'Erweiterungen',
    close: 'Schließen',
    modalFocus: 'Formular fokussieren',
    modalFullscreen: 'Vollbild öffnen',
    modalRestore: 'Größe wiederherstellen',
    filterByColumn: 'Nach {column} filtern',
    formCustomFieldsLoading: 'Benutzerdefinierte Felder werden geladen…',
    formCustomFieldsLoadError: 'Benutzerdefinierte Felder konnten nicht geladen werden. Versuchen Sie es vor dem Speichern erneut, um Datenverlust zu vermeiden.',
    formCustomFieldsRetry: 'Erneut versuchen',
    pageUnavailableTitle: 'Die Seite konnte nicht geöffnet werden',
    pageUnavailableMessage: 'Sie können über das Menü eine andere Seite öffnen oder diese Seite neu laden.',
    pageReloadWarning: 'Beim Neuladen gehen ungespeicherte Änderungen verloren.',
    allTargetLanguages: 'Alle Sprachen (10 Sprachen)',
    darkMode: 'Dunkelmodus',
    lightMode: 'Hellmodus',
    errorOccurred: 'Ein Fehler ist aufgetreten',
    confirm: 'Bestätigen',
    context: 'Tabelle',
    key: 'Spalte',
    originalShort: 'Orig.',
    originalValue: 'Originalwert',
    locale: 'Sprache',
    value: 'Wert',
    status: 'Status',
    auto: 'Auto',
    manual: 'Manuell',
    manageLocales: 'Sprachen verwalten',
    updateUntranslatedFields: 'Neue Felder synchronisieren',
    autoTranslate: 'Automatisch übersetzen',
    sourceAndTargetMustDiffer: 'Quell- und Zielsprache müssen unterschiedlich sein.',
    autoTranslateSuccessCount: '{count} Einträge automatisch übersetzt.',
    syncEntriesResult: '{count} neue Übersetzungseinträge synchronisiert.',
    translated: 'Translated',
    missing: 'Fehlend',
    autoTranslateScope: 'Automatischer Übersetzungsumfang',
    updateUntranslatedFieldsHint: 'Klicken Sie auf "Neue Felder aktualisieren", um Inhalte aus diesen Tabellen zu synchronisieren.',
    processing: 'Wird verarbeitet...',
    enterTargetLanguage: 'Zielsprache wählen.',
    sourceLanguage: 'Quellsprache',
    selectLanguagesFirst: 'Wählen Sie zuerst Sprachen unter Sprachen verwalten',
    sourceLanguageLabel: 'Quellsprache (Ihre UI-Sprache)',
    targetLanguage: 'Zielsprache',
    activeLocalesDescription: 'Aktive Sprachen auswählen. Nur als Einstellung gespeichert.',
    selectSourceLanguageForSync: 'In welcher Sprache sind die Inhalte?',
    languageNames: {
      en: 'Englisch',
      tr: 'Türkisch',
      de: 'Deutsch',
      fr: 'Französisch',
      es: 'Spanisch',
      ar: 'Arabisch',
      it: 'Italienisch',
      ja: 'Japanisch',
      zh: 'Chinesisch',
      ru: 'Russisch',
    },
    warning: 'Warnung',
  },
  login: {
    ...coreMessages.login,
    loginFailed: 'Anmeldung fehlgeschlagen',
    emailRequired: 'E-Mail-Adresse ist erforderlich',
    passwordRequired: 'Passwort ist erforderlich',
    backendUnavailable: 'Backend-Server derzeit nicht verfügbar. Bitte später erneut versuchen.',
    backendConnectFailed: 'Verbindung zum Backend-Server nicht möglich. Bitte später erneut versuchen.',
    backendConnectFailedDev: 'Verbindung zum Backend-Server nicht möglich. Stellen Sie sicher, dass der Server läuft ({apiUrl}).',
    emailLabel: 'E-Mail',
    emailPlaceholderFull: 'E-Mail-Adresse eingeben',
    passwordLabel: 'Passwort',
    passwordPlaceholderFull: 'Passwort eingeben',
    hidePassword: 'Passwort verbergen',
    showPassword: 'Passwort anzeigen',
    loggingIn: 'Anmeldung läuft...',
    submitButton: 'Anmelden',
    errors: {
      ...coreMessages.login.errors,
      invalidCredentials: 'E-Mail oder Passwort ungültig. Bitte versuchen Sie es erneut.',
      sessionTooLarge: 'Sitzungsdaten sind zu groß. Bitte melden Sie sich erneut an.',
      databaseUnavailable: 'Datenbank nicht erreichbar oder Einrichtung erforderlich. Bitte melden Sie sich erneut an.',
      accountInactive: 'Ihr Konto ist nicht aktiv. Bitte wenden Sie sich an Ihren Systemadministrator.',
      sessionExpired: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
      tooManyAttempts: 'Zu viele Versuche. Bitte versuchen Sie es später erneut.',
    },
    featureTitle: "Verbinden Sie Betriebs- und Finanzdaten",
    featureDescription: "Verfolgen Sie Bestand, Einkauf, Verkauf und Finanzdaten mit QubePro ERP.",
    featureCard1Title: "Produkte und Bestand",
    featureCard1Description: "Verwalten Sie Produkte, Lager und Bestandsbewegungen.",
    featureCard2Title: "Einkauf",
    featureCard2Description: "Verfolgen Sie Einkaufsbelege und Bestellungen.",
    featureCard3Title: "Verkaufsbelege",
    featureCard3Description: "Verwalten Sie Verkaufsaufträge und Rechnungen.",
    featureCard4Title: "Finanzbewegungen",
    featureCard4Description: "Prüfen Sie Bank-, Kassen- und Finanzdaten.",
    darkMode: 'Dunkelmodus',
    lightMode: 'Hellmodus',
    pleaseWait: 'Bitte warten',
    serverConfiguring: 'Server wird konfiguriert, bitte warten...',
    dbCreating: 'Datenbank und erforderliche Konfigurationen werden erstellt. Dies kann einige Sekunden dauern.',
    loginPageTitle: 'Anmeldung',
    languageToggleLabel: 'Sprachauswahl',
  },
  sidebar: {
    ...coreMessages.sidebar,
    dashboard: 'Dashboard',
    settings: 'Einstellungen',
    toggleMenu: 'Menü öffnen',
    toggleMenuClose: 'Menü schließen',
    companies: 'Unternehmen',
    logout: 'Abmelden',
    activityLogs: 'Aktivitätsprotokolle',
  },
  customFields: {
    title: 'Benutzerdefinierte Felder',
    newField: 'Neues benutzerdefiniertes Feld',
    editField: 'Benutzerdefiniertes Feld bearbeiten',
    entityType: 'Datensatztyp',
    code: 'Feldcode',
    label: 'Anzeigename',
    codePlaceholder: 'z. B. risikoStufe',
    labelPlaceholder: 'z. B. Sondercode 1',
    dataType: 'Datentyp',
    type: 'Typ',
    scope: 'Geltungsbereich',
    companyId: 'Firmen-ID',
    companySelection: 'Firmen',
    companySelectionPlaceholder: 'Leer ist global, oder Firmen auswählen',
    selectedCompanies: '{{count}} Firmen ausgewählt',
    selectAllCompanies: 'Alle Firmen auswählen',
    sortOrder: 'Reihenfolge',
    required: 'Pflichtfeld',
    searchable: 'Durchsuchbar',
    showInForm: 'Im Formular anzeigen',
    showInList: 'Spalte anzeigen',
    formTab: 'Formular-Tab',
    formTabSelect: 'Formular-Tab',
    formTabPlaceholder: 'Leer nutzt den Tab Benutzerdefinierte Felder',
    defaultCustomTab: 'Benutzerdefinierte Felder',
    selectEntityTypeFirst: 'Zuerst Datensatztyp auswählen',
    newFormTab: 'Neuer Tab',
    tabCode: 'Tab-Code',
    tabName: 'Tab-Name',
    tabCodePlaceholder: 'z. B. operationen',
    tabNamePlaceholder: 'z. B. Operationsdaten',
    fieldWidth: 'Zeilenlayout',
    widthFull: '1 Feld pro Zeile',
    widthHalf: '2 Felder pro Zeile',
    widthThird: '3 Felder pro Zeile',
    widthQuarter: '4 Felder pro Zeile',
    systemField: 'Systemfeld',
    description: 'Beschreibung',
    options: 'Optionen',
    optionsPlaceholder: 'Je Zeile: code:Label\nBeispiel: draft:Entwurf\noder nur Entwurf',
    defaultValue: 'Standardwert',
    statusDistributionTitle: '{{title}} Statusverteilung',
    emptyMessage: 'Noch keine benutzerdefinierten Felder definiert.',
    globalScope: 'Global',
    companyScope: 'Firma {{id}}',
    deleteSelected: 'Auswahl löschen',
    deleteSelectedMessage: '{{count}} benutzerdefinierte Felder werden gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
    formDesigner: 'Formulardesign',
    formDesignerTitle: 'Formulardesign für benutzerdefinierte Felder',
    formDesignerEntityType: 'Zu gestaltender Datensatztyp',
    formDesignerAllTabs: 'Alle',
    formDesignerEmpty: 'Für diesen Datensatztyp gibt es keine benutzerdefinierten Felder.',
    formDesignerOriginalNotice: 'Originale Formularfelder bleiben erhalten; diese Ansicht verwaltet Tabs, Reihenfolge und Zeilenlayout der benutzerdefinierten Felder.',
    formDesignerSave: 'Design speichern',
    formDesignerSaved: 'Formulardesign gespeichert.',
    formDesignerMoveUp: 'Nach oben',
    formDesignerMoveDown: 'Nach unten',
    formDesignerFieldSettings: 'Feldlayout',
    formDesignerQuickSave: 'Speichern',
    formDesignerEditTab: 'Tab bearbeiten',
    formDesignerDeleteTab: 'Tab löschen',
    formDesignerTabEditorTitle: 'Tab-Einstellungen',
    formDesignerCloseTabEditor: 'Tab-Editor schließen',
    dataTypes: {
      text: 'Text',
      number: 'Zahl',
      date: 'Datum',
      datetime: 'Datum/Uhrzeit',
      boolean: 'Ja/Nein',
      select: 'Auswahl',
      json: 'JSON',
    },
  },
  activityLogs: {
    title: 'Aktivitätsprotokolle',
    searchPlaceholder: 'Suchen (Entitätsname, Modul, Aktion)…',
    allModules: 'Alle Module',
    allActions: 'Alle Aktionen',
    allSeverity: 'Alle Schweregrade',
    allApps: 'Alle Anwendungen',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    exportCsv: 'CSV exportieren',
    total: 'Gesamt',
    today: 'Heute',
    critical: 'Kritisch',
    warning: 'Warnung',
    severityInfo: 'Info',
    exportFilenameStem: 'aktivitaetsprotokolle',
    noLogs: 'Keine Aktivitätsprotokolle gefunden.',   system: 'System',
    field: 'Feld',
    oldValue: 'Alter Wert',
    newValue: 'Neuer Wert',
    ip: 'IP',
    meta: 'Anforderungs-Metadaten',
    userAgent: 'User-Agent',
    entity: 'Entität',
    severityCol: 'Schweregrad',
    userCol: 'Benutzer',
    actionCol: 'Aktion',
    moduleCol: 'Modul',
    dateCol: 'Datum',
    appCol: 'Anwendung',
    overviewTitle: 'Übersicht',
    severityChart: 'Verteilung der Schweregrade',
    topModulesChart: 'Top-Module nach Volumen',
    csvId: 'ID',
    csvDate: 'Datum',
    csvUser: 'Benutzer',
    csvAction: 'Aktion',
    csvModule: 'Modul',
    csvEntity: 'Entität',
    csvSeverity: 'Schweregrad',
    csvIp: 'IP',
    csvApplication: 'Anwendung',
    companyCol: 'Firmen-ID',
    allOutcomes: 'Alle Ergebnisse',
    noLogsDesc: 'Protokolle erscheinen hier, sobald Benutzer Aktionen ausführen.',
    entityType: 'Eintragstyp',
    actorType: 'Akteurstyp',
    outcome: 'Ergebnis',
    successful: 'Erfolgreich',
    failed: 'Fehlgeschlagen',
    denied: 'Abgelehnt',
    reason: 'Begründung',
    requestId: 'Anfrage-ID',
    correlationId: 'Korrelations-ID',
    integrity: 'Integritätsnachweis',
    outboxWarning: 'Die Audit-Zustellwarteschlange erfordert Aufmerksamkeit.',
  },

  // Header Notifications page
  headerNotifications: {
    tabNotifications: 'Benachrichtigungen',
    tabPreferences: 'Einstellungen',
    markAllRead: 'Alle als gelesen markieren',
    notifCount: '{total} Benachrichtigungen',
    unreadCount: '{count} ungelesen',
    loading: 'Benachrichtigungen werden geladen...',
    noNotifications: 'Keine Benachrichtigungen',    markRead: 'Als gelesen markieren',
    delete: 'Löschen',   noPreferences: 'Keine Einstellungen',
    noPreferencesDesc: 'Noch keine Benachrichtigungskategorien vorhanden. Einstellungen werden automatisch erstellt, wenn Benachrichtigungen eingehen.',
    preferencesHeader: 'In-App-Benachrichtigungseinstellungen',
    prefItemDesc: 'Benachrichtigungen dieser Kategorie in der App empfangen',
    readDistribution: 'Verteilung des Lesestatus',
    readStatusLabel: 'Lesestatus',
    filterAll: 'Alle',
    filterUnread: 'Ungelesen',
    filterRead: 'Gelesen',    colType: 'Typ',
    colTitle: 'Titel',
    colMessage: 'Nachricht',
    colDate: 'Datum',
    colRead: 'Status',
    statusUnread: 'Ungelesen',
    statusRead: 'Gelesen',
    searchNotifications: 'Titel oder Nachricht suchen…',
  },
};
